import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ApplicationPageTemplate from "../../../dashboard/components/ApplicationPageTemplate/ApplicationPageTemplate";
import { DataGrid } from "@mui/x-data-grid";
import { Chip } from "@mui/material";
import { VouchersFilter } from "src/components/VouchersFilter";
import styled from "styled-components";
import { useDispatch, useSelector } from 'react-redux';
import { getBulkPurchaseDetails, getAllVouchersByBulkPurchaseId } from '@store/bulk-purchase-list-vouchers';
import moment from 'moment';

const DEEPLINK_BASE_URL = process.env.REACT_APP_DEEPLINK_BASE_URL;

const TitleCell = styled.div`
	min-width: 100%;
	flex: 1;
	font-weight: 500; 
`;

const voucherFilterProps = {
	required: true,
	fullWidth: true,
	width: '250px',
	margin: 'normal',
};

const ViewVouchers = () => {
	const { id } = useParams();
	const dispatch = useDispatch();
	const [selectedField, setSelectedField] = useState('');
	const [searchValue, setSearchValue] = useState(null);
	const [searchFieldValue, setSearchFieldValue] = useState(null);
	const [rowsDataGrid, setRowsDataGrid] = useState([]);
	const [paginationModel, setPaginationModel] = useState({
		pageSize: 25,
		page: 0,
	});
	const vouchersList = useSelector(state => state.bulkPurchaseVouchersList.vouchers);
	const bulkPurchaseDetails = useSelector(state => state.bulkPurchaseVouchersList.bulkPurchaseDetails);
	useEffect(() => {
		if (id) {
			dispatch(getBulkPurchaseDetails({ bulkPurchaseId: id }));
			dispatch(getAllVouchersByBulkPurchaseId({ bulkPurchaseId: id, searchValue: searchValue, pageNumber: paginationModel.page, pageSize: paginationModel.pageSize }));
		}
	}, [dispatch, id, paginationModel, searchValue]);

	useEffect(() => {
		if (vouchersList) {
			setRowsDataGrid([...vouchersList]);
		}
	}, [vouchersList]);

	const onSelectChangeHandler = (e) => {
		if (e && e.target && e.target.value) {
			setSelectedField(e.target.value)
		}
	};

	const onSearchClickHandler = (e) => {
		try {
			if(selectedField == 'voucher_deep_link'){
				const deeplink = new URL(searchFieldValue);
				const args =  new URLSearchParams(deeplink.search);
				setSearchValue(args.get('code'));
			} 
		} catch (error) {
			alert("Please select correct filter and value!")
		}
	}

	const onResetClickHandler = (e) => {
		window.location.reload();
	}

	const onSearchChangeHandler = (e) => {
		setSearchFieldValue(e.target.value)
	}

	const columns = [
		{
			field: "deeplink",
			headerName: "Deep Link",
			width: 980,
			renderCell: ({ row }) => {
				return (
					<>{`${DEEPLINK_BASE_URL}/redeem?code=${row.voucherCode}&bulkPurchaseId=${id}`}</>
				);
			},
		},
		{
			field: "isRedeem", headerName: "Status", width: 130, renderCell: (params) => {
				let color = 'success';
				let label = 'Active'
				if (params.value === true) {
					color = 'warning';
					label = 'Redeemed';
				}
				return <Chip label={label} color={color} variant="outlined" />
			},
		},
		{
			field: "redeemedDate",
			headerName: "Redeem Date",
			width: 210,
			renderCell: (params) => (
				<div>
					<>{(params.value == null ? '-' : moment(new Date(params.value), '').format() )}</>
				</div>
			),
		},
	];
	return (
		<ApplicationPageTemplate title={"View Bulk Purchase Vouchers"} description={`List of all vouchers`} pageReady={true}>
			<div style={{ height: 800, width: "100%" }}>
				<VouchersFilter
					{...voucherFilterProps}
					onSelectChangeHandler={onSelectChangeHandler}
					onSearchChangeHandler={onSearchChangeHandler}
					onSearchClickHandler={onSearchClickHandler}
					onResetClickHandler={onResetClickHandler}
					downloadUrl={bulkPurchaseDetails.csvLink}
				/>
				<DataGrid
					columns={columns}
					rows={rowsDataGrid}
					rowClassName="fixed-height-cell"
					rowHeight={70}
					rowCount={bulkPurchaseDetails ? bulkPurchaseDetails.quantity : 0 }
					loading={false}
					pageSizeOptions={[10, 25, 50 , 100]}
					paginationModel={paginationModel}
					paginationMode="server"
					onPaginationModelChange={setPaginationModel}
				/>
			</div>
		</ApplicationPageTemplate>
	);
};

export default ViewVouchers;